export const sectionConfigs = {
  connectedAccounts: {
    title: 'Connected accounts',
    description: 'Manage accounts linked for sign-in.',
    iconBg: '#e5f6fd',
    iconColor: '#448af7',
  },
  contactInfo: {
    title: 'Creator contact info',
    description:
      'The contact information on file for your creator account or the creator account you manage.',
    iconBg: '#eee',
    iconColor: '#646464',
  },
  customDomain: {
    title: 'Custom domain',
    description: 'Personalize your public URL with your own domain',
    iconBg: '#ede5fc',
    iconColor: '#350584',
  },
  featureSettings: {
    title: 'Feature settings',
    description: 'Manage features for your creator account.',
    iconBg: '#eee',
    iconColor: '#646464',
  },
} as const;
